import { createSelector } from 'reselect'
import {
  selectInstantOfferVideoType,
  selectInstantOfferVideoId
} from './videos'
import { every } from './utils'

const selectPowerUps = state => state.powerUps

export const getSelectConfigurationFromPowerUps = code =>
  createSelector(selectPowerUps, powers => {
    return powers && powers[code] ? powers[code].configuration : undefined
  })

export const selectFieldFromPowerupConfiguration = (code, field) =>
  createSelector(getSelectConfigurationFromPowerUps(code), config =>
    config ? config[field] : undefined
  )

export const selectInstantOfferEnabled = createSelector(
  selectInstantOfferVideoType,
  selectInstantOfferVideoId,
  every
)
